import { render } from "./Form.vue?vue&type=template&id=1082de52&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=1082de52&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kevin\\Desktop\\AirFryer\\AirFryer_Berater\\AirFryer_Kaufberatung\\form_try0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1082de52"]])

export default __exports__